import template from './animation.html'

import css from './animation.css'
import { AnimationController } from './animation.controller.js'
import { SimulatorController } from '../../simulator.controller.js'

export const AnimationComponent = {
  template: template,
  controller: AnimationController,
  controllerAs: 'AnimationController',
  bindings: {
    //clickMouvement: '='
  },
  require: {
    parentSimulator: '^^simulatorComponent'
  }
}



// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/animation/animation.component.js